/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {ContentHeader, Loader, DatePicker} from '@components';
import {logoutUser} from '@app/store/reducers/auth';
import {Button, Modal} from 'react-bootstrap';
import {format, endOfDay, startOfDay} from 'date-fns';
import {removeTags} from '@app/utils/helpers';
import Pagination from '../components/pagination/index';
import {getAllDailies} from '../../src/services/daily';
import handleStatus from '../utils/ajax';

const ONE_DAY_MS = 86400000;

function ModalPopup({daily, handleClose}: any) {
  return (
    <Modal
      show
      onHide={handleClose}
      centered
      dialogClassName="custom-modal-width"
    >
      <Modal.Header>
        <Modal.Title>Your daily</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{maxHeight: '400px', overflowY: 'auto'}}>
        <span>
          <b>Goals</b>
        </span>
        <div
          className="view-status"
          dangerouslySetInnerHTML={{__html: daily.goals}}
        />
        <span>
          <b>Status</b>
        </span>
        <div
          className="view-status"
          dangerouslySetInnerHTML={{__html: daily?.status}}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const MyDailies = () => {
  const [goals, setGoals] = useState([]);
  const [selected, setSelected] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [daily, setDaily] = useState(null);
  const [startDate, setStartDate] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const datePickerRef = React.useRef<{resetDatePicker: () => void} | null>(
    null
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getAll = async (query: any) => {
    console.log(query, 'query');
    setShowLoader(true);
    const resp = await getAllDailies(query);
    // console.log(resp, 'response*********************');
    handleStatus(resp?.status, () => dispatch(logoutUser()), navigate);
    setShowLoader(false);
    if (resp.data.ok === true) {
      if (resp.data.data) {
        setGoals(resp.data.data);
        setTotalRecords(resp.data.totalRecords);
        // console.log(goals, "aaaaa")
      }
    }
  };

  useEffect(() => {
    getAll({});
  }, []);

  const handleChange = (e: any) => {
    if (datePickerRef.current) {
      datePickerRef.current.resetDatePicker();
    }

    const value = e.target.value.toLowerCase();
    let newStartDate: number = 0;
    let newEndDate: number = 0;

    if (value === 'today') {
      newStartDate = startOfDay(new Date()).getTime();
      newEndDate = endOfDay(new Date()).getTime();
    } else if (value === 'yesterday') {
      const yesterday = new Date().getTime() - ONE_DAY_MS;
      newStartDate = startOfDay(new Date(yesterday)).getTime();
      newEndDate = endOfDay(new Date(yesterday)).getTime();
    }

    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setSelected(value);
  };

  const handleCustomDateChange = ({startDate, endDate}: any) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const filter = () => {
    getAll({startDate, endDate});
  };

  const isTodayDaily = (date: any) => {
    const today = new Date();
    const todayDate = format(today, 'yyyy-MM-dd');
    const dailyDate = format(date, 'yyyy-MM-dd');
    return todayDate === dailyDate;
  };

  const pagination = (page: number) => {
    getAll({startDate, endDate, page});
  };

  const handlePopup = (daily: any) => {
    setShowPopup(true);
    setDaily(daily);
  };

  const handleClose = () => {
    setShowPopup(false);
    setDaily(null);
  };

  const paginate = (pageno: number) => {
    getAll({startDate, endDate, pageNo: pageno});
    setCurrentPage(pageno);

    // setCurrentPage(pageno);
  };

  const resetAllDailies = () => {
    if (datePickerRef.current) {
      datePickerRef.current.resetDatePicker();
    }
    setStartDate(0);
    setEndDate(0);
    
    setSelected('all');
    getAll({});
  };

  return (
    <>
      <div>
        <ContentHeader title="My Dailies" />
        {showPopup && <ModalPopup handleClose={handleClose} daily={daily} />}
        <section className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">All About My Dailies</h3>
              </div>
              <div className="card-body">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header d-flex justify-content-end flex-wrap">
                      {/* <h3 className="m-0">Dailies</h3> */}
                      {/* <div className="container d-flex justify-content-end"> */}
                      <div className="col-md-3">
                        <DatePicker
                          ref={datePickerRef}
                          onSelect={handleCustomDateChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <select
                          className="form-control"
                          value={selected}
                          onChange={handleChange}
                        >
                          <option value="all">All</option>
                          <option value="today">Today</option>
                          <option value="yesterday">Yesterday</option>
                        </select>
                      </div>
                      <div className="col-md-1">
                        <Button onClick={filter} variant="primary">
                          Search
                        </Button>
                      </div>

                      <div className="col-md-1">
                        <Button onClick={resetAllDailies} variant="primary">
                          Reset
                        </Button>
                      </div>
                    </div>
                    <div className="card-body table-responsive p-0">
                      {showLoader ? (
                        <Loader title="My Dailies" />
                      ) : (
                        <table className="table table-hover text-nowrap">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th style={{textAlign: 'center'}}>Start Time</th>
                              <th style={{textAlign: 'center'}}>Break Time</th>
                              <th style={{textAlign: 'center'}}>End Time</th>
                              <th style={{textAlign: 'center'}}>Total Hours</th>
                              <th style={{textAlign: 'center'}}>Dailies</th>
                              <th style={{textAlign: 'right'}}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {goals.map(
                              (
                                {
                                  created_At: createdAt,
                                  status,
                                  breakTime,
                                  updated_At: updatedAt,
                                  totalHours,
                                  goals
                                }: any,
                                index
                              ) => {
                                function getRemainingAfterBreak(t1: any, t2: any, breakTime:string) {
                                  const diffSeconds = Math.abs(t1 - t2) / 1000;
                                  const breakSeconds = breakTimeToMinutes(breakTime) * 60;
                                  const remainingSeconds = diffSeconds - breakSeconds; 
                                
                                  const workTime = 7 * 60 * 60 + ( 45 * 60 ); 
                                  const isGood = workTime - remainingSeconds < 0 ? true : false;
                                  return isGood;  
                                }
  
                                function showRedBg(createdAt:number, updatedAt:number, breakTime:string) {
                                  const isStatusPending = (!isTodayDaily(createdAt) && !status);
  
                                  if(isStatusPending) {
                                    return "daily-missed";
                                  }
  
                                  if(!status){
                                    return 'user-daily';
                                  }
  
                                  const remainingAfterBreak = !getRemainingAfterBreak(createdAt, updatedAt, breakTime) ? "daily-flagged" : "user-daily";
                                  return remainingAfterBreak;
                             
                                }
  
                                function breakTimeToMinutes(breakTimeString:string = '0h45m') {
                                  if(!breakTimeString) return 0;
  
                                  const hoursMatch = breakTimeString.match(/(\d+)h/);
                                  const minutesMatch = breakTimeString.match(/(\d+)m/);
                                
                                  const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
                                  const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
                                
                                  return hours * 60 + minutes;
                                }
                                 
                                return (
                                  <tr
                                    className={
                                      showRedBg(createdAt, updatedAt, breakTime)
                                    }
                                  >
                                    <td>
                                      {format(
                                        new Date(createdAt),
                                        'MM/dd/yyyy'
                                      )}
                                    </td>
                                    <td style={{textAlign: 'center'}}>
                                      {format(new Date(createdAt), 'h:mm a')}
                                    </td>

                                    <td style={{textAlign: 'center'}}>
                                      {breakTime || 'N/A'}
                                    </td>

                                    <td style={{textAlign: 'center'}}>
                                      {format(new Date(updatedAt), 'h:mm a')}
                                    </td>
                                    <td style={{textAlign: 'center'}}>
                                      {totalHours || 'N/A'}
                                    </td>
                                    <td
                                      style={{textAlign: 'center'}}
                                    >{`${removeTags(goals).substring(
                                      0,
                                      8
                                    )}...`}</td>
                                    <td style={{textAlign: 'right'}}>
                                      <Button
                                        variant="primary"
                                        onClick={() =>
                                          handlePopup({
                                            status,
                                            breakTime,
                                            totalHours,
                                            goals
                                          })
                                        }
                                      >
                                        View
                                      </Button>{' '}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Pagination
        postsPerPage={postPerPage}
        totalPosts={totalRecords}
        paginate={paginate}
        currentPage={currentPage}
      />
    </>
  );
};

export default MyDailies;
